import { createContext, useEffect, useState } from "react";
import { getMonths } from "../utils/getData";

export const CancelContext = createContext({
    userInfo: {},
    cancelInfo: {},
    loading: true,
    changeUserInfo: () => {},
    changeCancelInfo: () => {},
    getTitle: () => {},
    getDesc: () => {},
    getPauseOption: ()=>{},
    setLoading: () => {}
});

export const CancelProvider = ({children}) => {
    const [userInfo, setUserInfo] = useState({});
    const [cancelInfo, setCancelInfo] = useState({});
    const [loading, setLoading] = useState(true);
    const changeUserInfo = (newUserInfo) =>{
        setUserInfo({...userInfo,...newUserInfo});
    }

    useEffect(()=>{
        if(userInfo.next_renewal && userInfo.plan_code){
            let dateObj = new Date(userInfo.next_renewal);
            let dateObjToAdd = new Date(userInfo.next_renewal);
            let dateAdd = userInfo.plan_code.includes("-s")? 7 :userInfo.plan_code.includes("-e")?14:21;
            let addedDate = new Date(dateObjToAdd.setDate(dateObjToAdd.getDate() + dateAdd));
            setCancelInfo(previous=>({...previous, renew_text:`${(getMonths()[dateObj.getMonth()]).short} ${dateObj.getDate()}`,  install_renew_date: addedDate.toISOString() , renew_install_text:`${(getMonths()[addedDate.getMonth()]).short} ${addedDate.getDate()}`}));

        }
    },[userInfo.next_renewal, userInfo.plan_code]);

    useEffect(()=>{           
        if(userInfo.next_renewal && cancelInfo.chosen_date){
            let dateObj = new Date(userInfo.next_renewal);
            var lastDayOfMonth = new Date(dateObj.getFullYear(), dateObj.getMonth()+1, 0);
            let finalDate = cancelInfo.chosen_date < lastDayOfMonth.getDate()? cancelInfo.chosen_date: lastDayOfMonth.getDate();
            let next_bill_date = new Date(dateObj.setDate(finalDate));
            setCancelInfo(previous=>({...previous,  aligned_renew_date: next_bill_date.toISOString() ,aligned_renew_text:`${(getMonths()[dateObj.getMonth()]).short} ${finalDate}`}));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[cancelInfo.chosen_date]);

    const changeCancelInfo= (newCancelInfo) => {
        setCancelInfo({...cancelInfo,...newCancelInfo});
    }

    const getTitle = (page) =>{
        if(page==="offer"){
            if(cancelInfo.category === "fin_cat"){
                return "How does a lower price sound?"
            }else if(cancelInfo.category === "prod_cat"){
                return "Product issues?"
            } else {
                return "Canceling for personal reasons?"
            }
        } else if (page ==="keep"){
            if (cancelInfo.choice==="reduced"){
                return `Reduced price confirmed &#x1F911;`
            } else {
                return `We’re glad you stayed`
            }
        }
    }

    const getPauseOption = () =>{
        if(userInfo && userInfo.plan_code){
            if(userInfo.plan_code.search("-a") > 0){//not on btm yet
               return [{text:"2 weeks", value:"1"}, {text:"4 weeks", value:"2"}, {text:"6 weeks", value:"3"}];
            } else if(userInfo.plan_code.search("-s") > 0){
                return [{text:"1 month", value:"1"}, {text:"2 months", value:"2"}, {text:"3 months", value:"3"}];
            } else if(userInfo.plan_code.search("-e") > 0){
                return [{text:"2 month", value:"1"}, {text:"4 months", value:"2"}, {text:"6 months", value:"3"}];
            } else if(userInfo.plan_code.search("-q") > 0){
                return [{text:"3 month", value:"1"}, {text:"6 months", value:"2"}, {text:"9 months", value:"3"}];
            } 
          }
    }

    const value = {
        userInfo, 
        cancelInfo,
        loading,
        changeUserInfo,
        changeCancelInfo,
        getTitle,
        getPauseOption,
        setLoading
};

    return <CancelContext.Provider value={value}>
                <div className="loading-placeholder" style={{display:(loading?"block":"none")}}>
                    <div>
                        <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
                    </div>
                </div>        
                {children}
        </CancelContext.Provider>
}